import Base from './Base';

const ENTITY = 'partners';
export const REDUCER_NAME = ENTITY;

const initialState = { isFetching: true, isSingleObject: false, values: [] };
const contacts = new Base(ENTITY, initialState);

export const reducer = contacts.reducer.bind(contacts);
contacts.getAsync.bind(contacts);
contacts.putAsync.bind(contacts);
contacts.postAsync.bind(contacts);

export const get = () => {
  return contacts.getAsync(`${ENTITY}`);
};

export const post = (data) => {
  return contacts.postAsync(`${ENTITY}`, data);
};

export const put = (id, data) => {
  return contacts.putAsync(`${ENTITY}/${id}`, data);
};
export const del = (id) => {
  return contacts.deleteAsync(`${ENTITY}/${id}`);
};



// WEBPACK FOOTER //
// ./src/redux/modules/partners.js